import { render, staticRenderFns } from "./OrderCreatorServiceGlobalPackage.vue?vue&type=template&id=6edd76c2&scoped=true&"
import script from "./OrderCreatorServiceGlobalPackage.vue?vue&type=script&lang=js&"
export * from "./OrderCreatorServiceGlobalPackage.vue?vue&type=script&lang=js&"
import style0 from "./OrderCreatorServiceGlobalPackage.vue?vue&type=style&index=0&id=6edd76c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edd76c2",
  null
  
)

export default component.exports